/**
 * Cart Upsell Popup — assets/cart-upsell-popup.js
 * Reads config from #upsell-popup-config, builds product cards,
 * handles qty/price sync, ATC via /cart/add.js, and show/hide animations.
 */ 
(function () {
  'use strict';

  /* ── DOM refs ── */
  var overlay    = document.getElementById('upsell-popup-overlay');
  var headingEl  = document.getElementById('upsell-popup-heading');
  var subEl      = document.getElementById('upsell-popup-subheading');
  var listEl     = document.getElementById('upsell-products-list');
  var dismissEl  = document.getElementById('upsell-dismiss-link');
    var savingsEl  = document.getElementById('upsell-popup-savings');
  var closeBtn   = overlay ? overlay.querySelector('.upsell-close') : null;
  var configEl   = document.getElementById('upsell-popup-config');

  if (!overlay || !listEl) return;

  /* ── Parse config ── */
  var config = { heading: 'YOU ALSO NEED', subheading: '', dismissText: 'No, thanks', products: [] };
  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.warn('Upsell popup: invalid config JSON', e);
    }
  }

  /* Filter out null/empty entries (from trailing commas in Liquid) */
  var products = (config.products || []).filter(function (p) {
    return p && p.id && p.variantId;
  });

  /* ── Populate header ── */
  if (headingEl) headingEl.textContent = config.heading || 'YOU ALSO NEED';
  if (subEl) subEl.textContent = config.subheading || '';
  if (dismissEl) dismissEl.textContent = config.dismissText || 'No, thanks';

  /* ── Helpers ── */
  /* Use shop currency from Liquid config (cart.currency.iso_code +
     request.locale.iso_code). Falls back to the previous hardcoded EUR
     symbol if Intl.NumberFormat is unavailable or rejects the inputs \u2014
     so the popup never shows wrong-currency symbols on non-EUR shops,
     but never breaks if the locale string is malformed either. */
  var _moneyFormatter = null;
  try {
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      _moneyFormatter = new Intl.NumberFormat(config.locale || undefined, {
        style: 'currency',
        currency: config.currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  } catch (e) {
    _moneyFormatter = null;
  }

  function formatMoney(pence) {
    var amount = pence / 100;
    if (_moneyFormatter) {
      try { return _moneyFormatter.format(amount); } catch (e) { /* fall through */ }
    }
    return '\u20AC' + amount.toFixed(2);
  }

  function escHtml(str) {
    var el = document.createElement('span');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function escAttr(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ── Build product cards ── */
  products.forEach(function (prod, idx) {
    var card = document.createElement('div');
    card.className = 'upsell-card';
    card.setAttribute('data-index', idx);

    var descHtml = prod.description
      ? '<p class="upsell-card__desc">' + escHtml(prod.description) + '</p>'
      : '';

    card.innerHTML =
      '<div class="upsell-card__title-row">' +
        '<a href="' + escAttr(prod.url) + '" class="upsell-card__title">' + escHtml(prod.title) + '</a>' +
      '</div>' +

      '<div class="upsell-card__content">' +   // NEW WRAPPER

        '<div class="upsell-card__image">' +
          '<img src="' + escAttr(prod.image) + '" alt="' + escAttr(prod.title) + '" loading="lazy" width="90" height="90">' +
        '</div>' +

        '<div class="upsell-card__info">' +

          descHtml +

          '<div class="upsell-card__subtotal-row">' +
            '<span class="upsell-card__subtotal-label">Subtotal :</span>' +
            '<span class="upsell-card__price"  data-unit-price="' + prod.price + '">' + formatMoney(prod.price) + '</span>' +
          '</div>' + 

          '<div class="upsell-card__actions">' +
            '<div class="upsell-qty">' +
              '<button type="button" class="upsell-qty__btn" data-action="minus" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" class="upsell-qty__input" value="1" min="1" max="99" aria-label="Quantity">' +
              '<button type="button" class="upsell-qty__btn" data-action="plus" aria-label="Increase quantity">&plus;</button>' +
            '</div>' +
            '<button type="button" class="upsell-atc-btn" data-variant-id="' + prod.variantId + '">ADD TO CART</button>' +
          '</div>' +

        '</div>' +

      '</div>';

    listEl.appendChild(card);
  });

  /* ── Qty + Price sync (event delegation) ── */
  listEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.upsell-qty__btn');
    if (!btn) return;
    var card    = btn.closest('.upsell-card');
    var input   = card.querySelector('.upsell-qty__input');
    var priceEl = card.querySelector('.upsell-card__price');
    var action  = btn.getAttribute('data-action');
    var qty     = parseInt(input.value, 10) || 1;

    if (action === 'plus') qty++;
    if (action === 'minus' && qty > 1) qty--;

    input.value = qty;
    updateSubtotal(priceEl, qty);
  });

  listEl.addEventListener('change', function (e) {
    if (!e.target.classList.contains('upsell-qty__input')) return;
    var card    = e.target.closest('.upsell-card');
    var priceEl = card.querySelector('.upsell-card__price');
    var qty     = parseInt(e.target.value, 10);
    if (!qty || qty < 1) { qty = 1; e.target.value = 1; }
    updateSubtotal(priceEl, qty);
  });

  function updateSubtotal(priceEl, qty) {
    var unit = parseInt(priceEl.getAttribute('data-unit-price'), 10) || 0;
    priceEl.textContent = formatMoney(unit * qty);
  }

  /* ── ATC handler (event delegation) ── */
  listEl.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.upsell-atc-btn');
    if (!atcBtn || atcBtn.classList.contains('is-adding') || atcBtn.classList.contains('is-added')) return;

    var card      = atcBtn.closest('.upsell-card');
    var variantId = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
    var qtyInput  = card.querySelector('.upsell-qty__input');
    var qty       = parseInt(qtyInput.value, 10) || 1;

    atcBtn.classList.add('is-adding');
    atcBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function () {
      atcBtn.classList.remove('is-adding');
      atcBtn.classList.add('is-added');
      atcBtn.textContent = 'Added \u2713';

      /* Update cart icon bubble count */
      updateCartBubble();

      setTimeout(function () {
        closeAndOpenCartDrawer();
      }, 800);
    })
    .catch(function () {
      atcBtn.classList.remove('is-adding');
      atcBtn.textContent = 'ADD TO CART';
    });
  });

  /* ── Update cart icon bubble ── */
  function updateCartBubble() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        bubbles.forEach(function (b) { b.textContent = cart.item_count; });
        var srBubbles = document.querySelectorAll('.cart-count-bubble .visually-hidden');
        srBubbles.forEach(function (b) { b.textContent = cart.item_count + ' items'; });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.removeAttribute('hidden');
      })
      .catch(function () {});
  }

  /* ── Qty pre-fill: calculate recommended underlay/adhesive rolls from flooring qty ──
       Rule 1 — title contains "10m": 1 roll per 11 Y² → Math.ceil(qty / 11)
       Rule 2 — title contains "15m": 1 roll per 17 Y² → Math.ceil(qty / 17)
       Rule 3 — anything else (adhesive/Recoll):  1 tub per 15 Y² → Math.ceil(qty / 15) */
    function calcUnderlayQty(flooringQty, productTitle) {
      var title = (productTitle || '').toLowerCase();
      if (title.indexOf('10m') !== -1) return Math.ceil(flooringQty / 11);
      if (title.indexOf('15m') !== -1) return Math.ceil(flooringQty / 17);
      return Math.ceil(flooringQty / 15);
    }

    /* ── Qty pre-fill: calculate recommended rolls/tubs from the flooring qty ──
       Rule 1 — title contains "10m" → 1 roll per 11 Y²  (ceil(qty/11))
       Rule 2 — title contains "15m" → 1 roll per 17 Y²  (ceil(qty/17))
       Rule 3 — anything else (adhesive/Recoll) → 1 tub per 15 Y² (ceil(qty/15)) */
    function calcUnderlayQty(flooringQty, productTitle) {
      var title = (productTitle || '').toLowerCase();
      if (title.indexOf('10m') !== -1) return Math.ceil(flooringQty / 11);
      if (title.indexOf('15m') !== -1) return Math.ceil(flooringQty / 17);
      return Math.ceil(flooringQty / 15);
    }

    /* ── Savings summary: total saved across current cart line items
         (compare-at vs actual price), shown in red under the popup title. ── */
      function updateSavingsSummary() {
        if (!savingsEl) return;
        fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var items = cart.items || [];
            if (items.length === 0) {
              savingsEl.textContent = '';
              savingsEl.hidden = true;
              return;
            }

            /* Shopify's /cart.js line items don't expose compare_at_price
               (original_line_price/line_price only differ for discount
               codes, not plain sale/markdown pricing) — so we look up each
               distinct product's compare_at_price via /products/{handle}.js
               and match it against the cart line item's variant. */
            var handles = [];
            items.forEach(function (item) {
              if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
            });

            Promise.all(handles.map(function (handle) {
              return fetch('/products/' + handle + '.js')
                .then(function (r) { return r.ok ? r.json() : null; })
                .catch(function () { return null; });
            })).then(function (productDatas) {
              var productByHandle = {};
              handles.forEach(function (handle, i) { productByHandle[handle] = productDatas[i]; });

              var totalSavings = 0;
              items.forEach(function (item) {
                var productData = productByHandle[item.handle];
                if (!productData || !productData.variants) return;
                var variant = null;
                for (var i = 0; i < productData.variants.length; i++) {
                  if (productData.variants[i].id === item.variant_id) { variant = productData.variants[i]; break; }
                }
                if (!variant) return;
                var compareAt = variant.compare_at_price;
                var price = variant.price;
                if (compareAt && compareAt > price) {
                  totalSavings += (compareAt - price) * item.quantity;
                }
              });

              if (totalSavings > 0) {
                savingsEl.textContent = 'You are currently saving ' + formatMoney(totalSavings) + ' on your order!';
                savingsEl.hidden = false;
              } else {
                savingsEl.textContent = '';
                savingsEl.hidden = true;
              }
            });
          })
          .catch(function () {
            savingsEl.textContent = '';
            savingsEl.hidden = true;
          });
      }

      /* ── Show / Hide ── */
      var isOpen = false;

    function show(flooringQty) {
        if (isOpen) return;
        if (products.length === 0) return;
        flooringQty = parseInt(flooringQty, 10) || 1;

        updateSavingsSummary();

        /* Pre-fill each card's qty input + subtotal based on flooring quantity */
        listEl.querySelectorAll('.upsell-card').forEach(function (card, idx) {
          var prod = products[idx];
          if (!prod) return;
          var recommended = calcUnderlayQty(flooringQty, prod.title);
          var input   = card.querySelector('.upsell-qty__input');
          var priceEl = card.querySelector('.upsell-card__price');
          if (input) input.value = recommended;
          if (priceEl) updateSubtotal(priceEl, recommended);
        });

        isOpen = true;
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('upsell-open');
        if (closeBtn) closeBtn.focus();
      }

    function hide() {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('upsell-open');
      listEl.querySelectorAll('.upsell-atc-btn').forEach(function (btn) {
        btn.classList.remove('is-adding', 'is-added');
        btn.textContent = 'ADD TO CART';
      });

      /* Refresh cart drawer + icon bubble after popup closes.
         product-form.js skips renderContents() when the upsell
         popup is shown. We replicate the HTML update from
         renderContents() but skip open() to avoid trapFocus
         errors and an unwanted drawer slide-in. */
      var cartEl = document.querySelector('cart-drawer');
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        /* Remove is-empty from both <cart-drawer> and .drawer__inner
           so the cart shows line items instead of the empty state. */
        cartEl.classList.remove('is-empty');
        var drawerInner = cartEl.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');

        var sectionDefs = cartEl.getSectionsToRender();
        var sectionIds = sectionDefs.map(function (s) { return s.id; });
        fetch(window.routes.cart_url + '?sections=' + sectionIds.join(','))
          .then(function (r) { return r.json(); })
          .then(function (sectionsHTML) {
            sectionDefs.forEach(function (section) {
              var html = sectionsHTML[section.id];
              if (!html) return;
              var target = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              if (!target) return;
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var fresh = section.selector
                ? parsed.querySelector(section.selector)
                : parsed.querySelector('.shopify-section');
              if (fresh) target.innerHTML = fresh.innerHTML;
            });

            /* Re-attach overlay click handler lost during innerHTML replace.
               Mirrors renderContents() line 87. */
            var overlayEl = cartEl.querySelector('#CartDrawer-Overlay');
            if (overlayEl) overlayEl.addEventListener('click', cartEl.close.bind(cartEl));
          });
      }
    }

    /* ── Event: custom dispatch from flooring-calculator.js ── */
    document.addEventListener('fst:open-upsell-popup', function (e) {
      show(e.detail && e.detail.qty);
  });

  /* ── Fallback: intercept native form[action*="/cart/add"] submits ── */
  document.addEventListener('submit', function (e) {
    if (!window.upsellEnabled) return;
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.closest('.upsell-popup')) return;
    if (products.length === 0) return;
    e.preventDefault();

    var formData = new FormData(form);
    var items = [];
    var id = formData.get('id');
    var qty = parseInt(formData.get('quantity'), 10) || 1;
    if (id) items.push({ id: parseInt(id, 10), quantity: qty });

    if (items.length === 0) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function () {
      show(qty);
    })
    .catch(function () {
      window.location.href = '/cart';
    });
  }, true);

  /* ── Close handlers ── */
  function closeAndOpenCartDrawer() {
    hide();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
  if (closeBtn) closeBtn.addEventListener('click', closeAndOpenCartDrawer);
  if (dismissEl) dismissEl.addEventListener('click', function (e) {
    e.preventDefault();
    closeAndOpenCartDrawer();
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hide();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) hide();
  });

})();
